const defaultConfig = require('./default')

if (typeof window === 'undefined') {
  const path = require('path')
  const fs = require('fs')

  const fileExists = (filepath) => {
    try {
      return fs.statSync(filepath).isFile()
    } catch (e) {
      return false
    }
  }

  // 检查用于开发的配置文件是否存在，不存在自动用默认配置创建一个
  if (process.env.CODE_ENV === 'local') {
    const configFile = path.join(__dirname, 'local.js')

    if (!fileExists(configFile)) {
      fs.writeFileSync(configFile, fs.readFileSync(path.join(__dirname, 'local.example.js')))
    }
  }
}

const config = Object.assign(defaultConfig, require('./' + (process.env.CODE_ENV || 'local')))

;['VIEW_PATH', 'ADMIN_PATH', 'EDITOR_PATH', 'API_PATH'].map(k => {
  if (config[k] === '/') return
  if (/^(https?:)?\/\//.test(config[k])) {
    config[k] = config[k].replace(/\/*$/, '/')
  } else {
    config[k] = config[k].replace(/^\/*|\/*$/g, '/')
  }
})

if (!config.VIEW_NAME) {
  config.VIEW_NAME = process.env.NODE_ENV === 'development' ? '' : (config.VIEW_PATH.match(/([^/]+)\/?$/) || ['', 'view'])[1]
}

if (!config.EDITOR_NAME) {
  config.EDITOR_NAME = process.env.NODE_ENV === 'development' ? '' : (config.EDITOR_PATH.match(/([^/]+)\/?$/) || ['', 'editor'])[1]
}

// 用于办公网测试环境
if (typeof window !== 'undefined' && window.location.hostname === 'automan.fe.changbaops.com') {
  config.EDITOR_PATH = 'http://automan.fe.changbaops.com/auto/editor'
  config.VIEW_PATH = 'http://automan.fe.changbaops.com/auto/view/'
  config.API_PATH = 'http://automan.fe.changbaops.com/auto/api/'
  config.ADMIN_PATH = 'http://admin.automan.fe.changbaops.com/'
}

module.exports = config
